import React, { createRef } from "react";
import ReactTable from "react-table";
import Scrollbar from "react-scrollbars-custom";
import Search from "component/atoms/searchInput";
import "./DICOMTable.css";
import "./customScroll.styl";
import "./PopupDICOMTags.styl";

class PopupDICOMTags extends React.PureComponent {
  // private
  searchElement = createRef();

  static defaultProps = {
    dump: [],
    patientName: "",
    modality: "",
    studyDescription: "",
    windowObject: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchWord: "",
    };
  }

  componentDidMount() {
    const {
      patientName,
      modality,
      studyDescription,
      windowObject,
    } = this.props;

    if (!windowObject) {
      return;
    }
    const title =
      "DICOM Tags " + patientName + " " + modality + " " + studyDescription;
    windowObject.document.title = title;
    if (!!this.searchElement === true) {
      this.searchElement.focus();
    }
  }

  customScrollbar(tableState) {
    return (
      <Scrollbar noDefaultStyles permanentTrackX={true} permanentTrackY={true}>
        {" "}
        <div className="my-tbody-class"> {tableState.children} </div>{" "}
      </Scrollbar>
    );
  }
  render() {
    let { dump: filteredDump } = this.props;
    if (this.state.searchWord) {
      filteredDump = filteredDump.filter((row) => {
        return (
          row.tagId
            .toLowerCase()
            .includes(this.state.searchWord.toLowerCase()) ||
          row.vr.toLowerCase().includes(this.state.searchWord.toLowerCase()) ||
          row.description
            .toLowerCase()
            .includes(this.state.searchWord.toLowerCase()) ||
          row.value
            .toLowerCase()
            .includes(this.state.searchWord.toLowerCase()) ||
          String(row.vm)
            .toLowerCase()
            .includes(this.state.searchWord.toLowerCase()) ||
          String(row.length)
            .toLowerCase()
            .includes(this.state.searchWord.toLowerCase())
        );
      });
    }
    const columns = [
      {
        Header: "Tag ID",
        accessor: "tagId", // String-based value accessors!
        width: 116,
      },
      {
        Header: "VR",
        accessor: "vr",
        width: 45,
        Cell: (props) => <div className="text-center">{props.value}</div>, // Custom cell components!
      },
      {
        Header: "VM",
        accessor: "vm",
        width: 48,
        Cell: (props) => (
          <div className="number text-center">{props.value}</div>
        ), // Custom cell components!
      },
      {
        Header: "Length",
        accessor: "length",
        width: 76,
        Cell: (props) => (
          <div className="number text-center">{props.value}</div>
        ), // Custom cell components!
      },
      {
        Header: "Description",
        accessor: "description", // String-based value accessors!
        width: 262,
      },
      {
        Header: "Value",
        accessor: "value", // String-based value accessors!
        minWidth: 325,
      },
    ];
    return (
      <div className="popup-dicom-tags">
        <div className="DICOM-tag-table-section">
          <ReactTable
            data={filteredDump}
            columns={columns}
            showPagination={false}
            defaultPageSize={filteredDump.length}
            minRows={filteredDump.length}
            TbodyComponent={this.customScrollbar}
            noDataText=""
          />
        </div>
        <div className="search-input-section">
          <Search
            innerRef={(o) => (this.searchElement = o)}
            className="search-input"
            onChange={(value) => {
              this.setState({ searchWord: value });
              this.forceUpdate();
            }}
            throttle={20}
          />
        </div>
      </div>
    );
  }
}
export default PopupDICOMTags;
